import { useCallback, useState } from 'react';
import styles from 'styles/modules/popUps/Uploader.module.scss';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from 'helpers/canvas';
import Button from 'components/Button';
import CrosshatchLine from 'components/CrosshatchLine';

export default function UploaderCropper({ fileSrc, file, onSubmit }) {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const getCroppedImage = useCallback(
        async (e) => {
            e.preventDefault();
            try {
                const cropped = await getCroppedImg(
                    fileSrc,
                    croppedAreaPixels,
                    file.name
                );
                onSubmit(cropped);
            } catch (e) {
                console.error(e);
            }
        },
        [fileSrc, croppedAreaPixels]
    );

    const handleRangeChange = (e) => {
        const newZoom = parseFloat(e.target.value);
        setZoom(newZoom);
    };

    return (
        <div>
            <div className={styles.cropContainer}>
                <Cropper
                    image={fileSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                />
            </div>

            <div className={styles.cropControls}>
                <input
                    type="range"
                    min={1}
                    max={3}
                    value={zoom}
                    step={0.1}
                    onChange={handleRangeChange}
                    className={styles.cropRange}
                />

                <div className={styles.cta}>
                    <Button title={'Confirm'} onClick={getCroppedImage} />
                    <div className={styles.crosshatch}>
                        <CrosshatchLine />
                    </div>
                </div>
            </div>
        </div>
    );
}
